import { createApp } from 'vue'
import 'element-plus/theme-chalk/index.css';
import App from './App.vue'
createApp(App).mount('#app')
